import React from "react";
import { Link } from "react-router";
import Pagination from "../../components/Pagination";
import axios from "axios";
import Filter from "../../components/Filter";
import { getDeep } from "./../../functions.js";

export default class AuthoritiesOverview extends React.Component {
    constructor(props) {
        super(props);

        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        this.state = {
            resultRows: false,
            count: 0,
            limit: 0,
            offset: 0,
            activeFilters: {}
        };
    }

    cancelAxiosRequest = () => {
        this.cancelSource.cancel();

        this.setState({
            resultRows: false,
            count: 0,
            limit: 0,
            offset: 0
        });
    };

    handleFilter = (name, value) => {
        let activeFilters = this.state.activeFilters;
        activeFilters[name] = value;

        this.setState({
            activeFilters,
            offset: 0
        });
        this.getResults(this.state.offset);
    };

    getResults = (offset) => {
        this.cancelAxiosRequest();
        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        axios
            .get("/v1/authorities/", {
                params: {
                    offset: offset,
                    ...this.state.activeFilters
                },
                cancelToken: this.cancelSource.token
            })
            .then((response) => {
                this.setState({
                    resultRows: response.data.results,
                    count: response.data.count,
                    limit: response.data.limit,
                    offset: response.data.offset
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    deleteItem = (e, itemID, itemName) => {
        if (confirm(" Weet je zeker dat je deze bevoegdheid wilt verwijderen?")) {
            axios
                .delete("/v1/authorities/" + itemID + "/")
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De bevoegdheid '${itemName}' is succesvol verwijderd`
                    });
                    this.props.router.push("/authorities");
                    this.getResults(0);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    componentDidMount() {
        this.getResults(0);
    }

    render() {
        let tableRows = [];

        if (this.state.resultRows !== false) {
            let resultRows = this.state.resultRows;

            if (resultRows.length === 0) {
                tableRows.push(
                    <tr key="0">
                        <td colSpan="10">Met deze filters konden geen resultaten worden gevonden</td>
                    </tr>
                );
            }
            resultRows.forEach((result) => {
                tableRows.push(
                    <tr
                        key={result.code}
                        onClick={() => {
                            this.props.router.push("/authorities/edit/" + result.code);
                        }}
                    >
                        <td>{result.code}</td>
                        <td>{result.name}</td>
                        <td>
                            <i
                                className="fa fa-trash"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.deleteItem(e, result.code, result.name);
                                }}
                            ></i>
                        </td>
                    </tr>
                );
            });
        } else {
            tableRows.push(
                <tr key="1">
                    <td colSpan="10">Bevoegdheden ophalen...</td>
                </tr>
            );
        }

        return (
            <div>
                <div className="section-top">
                    <h1>Bevoegdheden</h1>

                    <div className="section-buttons">
                        {getDeep(this.props.permissions, "authority", "create") ? (
                            <Link to="/authorities/new" className="btn btn-primary">
                                Bevoegdheid toevoegen
                            </Link>
                        ) : (
                            false
                        )}
                    </div>
                </div>

                <div className="row">
                    <div className="col-3 filters"></div>
                    <div className="col-9">
                        <div className="filter-text-wrapper">
                            <Filter
                                title="Zoeken"
                                type="text"
                                filterName="search"
                                filters={[]}
                                handleFilter={(name, value) => this.handleFilter(name, value)}
                                activeFilters={this.state.activeFilters}
                            />
                            <i className="fa fa-search" />
                        </div>

                        <table className="table table-hover table-clickable">
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Titel</th>
                                    <th>Actie</th>
                                </tr>
                            </thead>
                            <tbody>{tableRows}</tbody>
                        </table>

                        <Pagination count={this.state.count} limit={this.state.limit} offset={this.state.offset} pageSwitch={(i) => this.getResults(i)} />
                    </div>
                </div>
            </div>
        );
    }
}
